import { setClassName, setAttr } from '../helpers/dom';

import Entities from './shared/Entities';
import { createState } from './shared/BasicState';
import { createScrollObserver } from './shared/ScrollTrigger';

export default class ToggleScrollEnter {
  constructor() {
    this.entities = new Entities(
      'ToggleScrollEnter',
      '[data-toggle-scroll-enter]',
      ToggleScrollEnter.initSingle,
      ToggleScrollEnter.destroySingle,
    );
  }

  static initSingle(containerEl) {
    const id = containerEl.getAttribute('data-toggle-scroll-enter');
    const stateId = containerEl.getAttribute('data-toggle-scroll-enter-state') ?? id;
    const key = containerEl.getAttribute('data-toggle-scroll-enter-key') ?? true;
    const mode = containerEl.getAttribute('data-toggle-scroll-enter-mode') ?? 'middle';

    const state = createState(stateId);

    // methods
    function onEnter() {
      state.set(key);
    }

    const scrollObserver = createScrollObserver(containerEl, { onEnter },
      mode === 'middle' ? {
        rootMargin: '-50%',
      } : {}
    );
    scrollObserver.observe();

    function destroy() {
      // scrollObserver.unobserve();
      scrollObserver.destroy();
    }

    return {
      destroy,
    };
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
